export const dashboardKeys = {
	all: ['dashboards'] as const,
	/** Every dashboard visible in one project, without configs. `scope` = tenant. */
	summaryList: (scope: string) => [...dashboardKeys.all, 'summaryList', scope] as const,
	/** One dashboard with its config, as last fetched or saved. `scope` = tenant. */
	detail: (scope: string, dashboardId: number) => [...dashboardKeys.all, 'detail', scope, dashboardId] as const,
	/** One dashboard's saved versions. `scope` = dashboard id. */
	history: (dashboardId: number) => [...dashboardKeys.all, 'history', dashboardId] as const,
	/** Every held sessions page, for dropping them all when a refresh goes to the network. */
	sessionsPages: () => [...dashboardKeys.all, 'sessionsPage'] as const,
	/** One fetched page of a sessions panel. `scope` = panel, device, time bucket and the view it was fetched for. */
	sessionsPage: (scope: readonly unknown[]) => [...dashboardKeys.sessionsPages(), ...scope] as const,
	/** Latest state and metadata for the devices a map panel has in view. `scope` = tenant, fields and ids. */
	mapDeviceDetails: (scope: readonly unknown[]) => [...dashboardKeys.all, 'mapDeviceDetails', ...scope] as const,
	/** One device's path on a map panel. `scope` = tenant, stream, columns, sampling, window and device. */
	deviceTrack: (scope: readonly unknown[]) => [...dashboardKeys.all, 'deviceTrack', ...scope] as const,
	/** The project's geofence outlines, shared by every map panel on a dashboard. `scope` = tenant. */
	geofenceAssets: (scope: readonly unknown[]) => [...dashboardKeys.all, 'geofenceAssets', ...scope] as const,
	/** How many devices a fleet scope matches. `scope` = tenant and fleet filters. */
	fleetDeviceCount: (scope: readonly unknown[]) => [...dashboardKeys.all, 'fleetDeviceCount', ...scope] as const,
}
